import { AxiosResponse } from 'axios';
import { ListData } from './utils';

export enum nokoPoints {
  GET_LIST = 'noko/student-progress/list',
  POST_PROGRESS = 'noko/student-progress/create',
  POST_COMPETITION = 'noko/competition/create',
  GET_MENTORS = 'inventory/experts/suggest',
}

export interface ProgressFormData {
  confirmation_file: any;
  student_id: string;
  partner_id: string;
  event_id: string;
  competition_id: string;
  date_finish: any;
  result: string;
  mentor_id: Array<string> | null;
}

export interface CompetitionFormData {
  level: string;
  name: string;
  organizer: string;
  link: string;
  type: string;
}

export interface CompetitionFormResponse {
  id: string;
}

export interface Mentor {
  id: string;
  name: string;
}

export type MentorsData = Array<Mentor>;

export interface Mentors {
  result: MentorsData;
  hint: string;
}

export type MentorsList = AxiosResponse<Mentors>;

export type List = AxiosResponse<ListData>;



// WEBPACK FOOTER //
// ./src/services/noko/types.ts